export default __webpack_public_path__ + "static/media/man_sitting.ade0957d.webp";